<template>
  <div
    id="top"
    :class="componentClass"
    :style="componentStyle"
  >
    <warning-internet-explorer v-if="isInternetExplorer" />
    <wa-admin-bar />

    <slot name="tophat">
      <subscription-notices />
      <usage-notices />
      <v7-prerelease-notice
        v-if="isShowingV7PrereleaseNotice"
        @show-livestream-modal="showLivestreamModal"
      />
    </slot>

    <slot name="header" />

    <slot
      v-if="isShowingBandana"
      name="bandana"
    >
      <wa-bandana
        bandana-name="v7TeaserBandana"
        @show-livestream-modal="showLivestreamModal"
      />
    </slot>

    <slot name="sweatband" />
    <slot name="content" />
    <slot name="sock" />
    <slot name="footer" />

    <slot
      v-if="isShowingSitewideModal"
      name="sitewide-modal"
    >
      <wa-modal-v7-livestream
        :is-showing="isShowingSitewideModal"
        @close-modal="hideLivestreamModal"
      />
    </slot>

    <slot name="overlay" />

    <cookie-consent />
  </div>
</template>

<script>
  const VERSION_TO_NAME = { 5: 'five', 6: 'six' }

  import { mapGetters } from 'vuex'
  import SubscriptionNotices from 'app/components-wa/messages/SubscriptionNotices'
  import UsageNotices from 'app/components-wa/messages/UsageNotices'
  import V7PrereleaseNotice from 'app/components-wa/messages/V7PrereleaseNotice'
  import WarningInternetExplorer from './WarningInternetExplorer'
  import CookieConsent from 'app/components-wa/messages/CookieConsent'
  import { v7PreSaleStatus } from 'app/views/plans/PlansData'

  export default {
    name: 'Page',

    components: {
      WarningInternetExplorer,
      SubscriptionNotices,
      CookieConsent,
      UsageNotices,
      V7PrereleaseNotice
    },

    provide() {
      return {
        currentVersion: {
          name: VERSION_TO_NAME[this.$releases.active.versionParts.major],
          number: this.$releases.active.versionParts.major
        }
      }
    },

    props: {
      customStyle: {
        type: Object,
        default: () => {}
      },
      isShowingBandana: {
        type: Boolean,
        default: true
      },
      isShowingV7PrereleaseNotice: {
        type: Boolean,
        default: false
      },
      viewSlug: {
        type: String,
        default: ''
      }
    },

    data() {
      return {
        isInternetExplorer: false,
        isShowingSitewideModal: false
      }
    },

    computed: {
      ...mapGetters('kits', ['currentKits']),

      isSignedIn() {
        return this.$route.meta.isSignedIn
      },

      componentClass() {
        return [`app-container size-sm tablet:size-md ${this.viewSlug}`]
      },

      componentStyle() {
        return {
          ...{ '--desktop-grid-max-width': 'var(--laptop-grid-max-width)' },
          ...this.customStyle
        }
      },

      isShowingKitDisabledNotice() {
        return this.currentKits.length > 0 && this.currentKits[0].status === 'deactivated' && this.currentKits[0].shutdownDate !== null
      }
    },

    mounted() {
      this.isInternetExplorer = !!document.documentMode

      const alreadyClosed = localStorage.getItem('livestreamClosed') === 'true'

      if (!alreadyClosed && v7PreSaleStatus.saleActive) {
        this.showLivestreamModal()
      }
    },

    methods: {
      showLivestreamModal() {
        this.$posthog.capture('livestream_modal_view')
        localStorage.setItem('livestreamClosed', 'false')

        this.isShowingSitewideModal = true
      },

      hideLivestreamModal() {
        localStorage.setItem('livestreamClosed', 'true')

        this.isShowingSitewideModal = false
      }
    }
  }
</script>
